import { createPayloadForWebCheckoutTrackingEvent } from "utils/mixpanel/web-checkout/web-checkout-mixpanel-utils";
import { useRouter } from "next/router";
import { useEffect } from "react";
import trackEvent from "services/mixpanel/mixpanel";
import { webCheckoutEventNames } from "services/mixpanel/web-checkout-events";
import { useAuth } from "stores/auth/auth-context";
import { IUsePaymentFailed } from "./use-payment-failed.types";

const usePaymentFailed = (): IUsePaymentFailed => {
  const router = useRouter();
  const { package: packageId, tenure: tenureId } = router.query;
  const { user } = useAuth();

  useEffect(() => {
    const payload = createPayloadForWebCheckoutTrackingEvent({
      useAuthData: user,
      Class: true,
      level: true,
      packageType: packageId ? packageId : null,
      tenureValue: tenureId ? tenureId : null,
      userFlow: true,
      failureReason: null
    });
    trackEvent({
      eventName: webCheckoutEventNames.paymentFailed,
      payload
    });
  }, []);

  const onClickRetryPayment = (): void => {
    const payload = createPayloadForWebCheckoutTrackingEvent({
      useAuthData: user,
      Class: true,
      level: true,
      packageType: packageId ? packageId : null,
      tenureValue: tenureId ? tenureId : null,
      userFlow: true,
      failureReason: null
    });
    trackEvent({
      eventName: webCheckoutEventNames.retryClickedAfterPaymentFailed,
      payload
    });
  };

  const onChatClick = (): void => {
    const payload = createPayloadForWebCheckoutTrackingEvent({
      useAuthData: user,
      Class: true,
      level: true,
      packageType: packageId ? packageId : null,
      tenureValue: tenureId ? tenureId : null,
      userFlow: true,
      failureReason: null
    });
    trackEvent({
      eventName: webCheckoutEventNames.chatClickedPaymentPopup,
      payload
    });
  };

  return { onClickRetryPayment, onChatClick };
};

export { usePaymentFailed };
